import request from '@/utils/request'

export function propagateList(data) {
    return request({
        url: `/AwardMobile/GetPropagateList`,
        method: 'post',
        data
    })
}

export function newsContentList(data) {
    return request({
        url: `/AwardMobile/GetNewsContentList`,
        method: 'post',
        data
    })
}
export function juryList(data) {
    return request({
        url: `/AwardMobile/GetJuryList`,
        method: 'post',
        data
    })
}
export function awardCateList(data) {
    return request({
        url: `/AwardMobile/GetAwardCateList`,
        method: 'post',
        data
    })
}
export function awardList(data) {
    return request({
        url: `/AwardMobile/GetAwardList`,
        method: 'post',
        data
    })
}
export function awardDetail(data) {
    return request({
        url: `/AwardMobile/GetAwardDetail`,
        method: 'post',
        data
    })
}
export function juryCommendArticleList(data) {
    return request({
        url: `/AwardMobile/GetJuryCommendArticleList`,
        method: 'post',
        data
    })
}
export function juryCommendArticleInfo(data) {
    return request({
        url: `/AwardMobile/GetJuryCommendArticleInfo`,
        method: 'post',
        data
    })
}